import React from 'react'
import starIcon from '@/assets/img/star-12x12.svg'
const RatingWidthIcon = ({ rating }: { rating: number | string }) => {
    return (
        <div className="flex items-center gap-6">
            <div className="flex">
                <img src={starIcon} alt="star" />
            </div>
            <span>{rating || 0}</span>
        </div>
    )
}

export default RatingWidthIcon
